import Vue from 'vue'
import Router from 'vue-router'

import Homepage from './views/Homepage.vue'
import Commitments from './views/Commitments.vue'
import Support from './views/Support.vue'


Vue.use(Router)

const router = new Router({
    base: process.env.BASE_URL,
    // mode: "history",
    routes: [
      {
        path: '/',
        name: 'Homepage',
        component: Homepage,
      },
      {
        path: '/commitments',
        name: 'Commitments',
        component: Commitments,
      },
      {
        path: '/support',
        name: 'Support',
        component: Support,
      },
      {
        path :'*',
        name: 'Homepage2',
        component: Homepage,
    }
    ],
    scrollBehavior () {
      return { x: 0, y: 0 }
    }
  })

export default router